import React from 'react';
import ReferralDetailsContainer from '../containers/ReferralDetailsPage/ReferralDetailsContainer';

const ReferralView = () => {
    return <ReferralDetailsContainer />;
};

export default ReferralView;
